/**
 * Organization display helpers.
 *
 * @module utils/org
 */

import type { Org } from '../types';

/**
 * Display label for an org in the picker.
 *
 * Handles the backend's **id-only degrade case**: when the staff admin's token
 * lacks ZITADEL instance-read authority, `GET /api/tenant-management/orgs`
 * returns 200 with entries whose `name`/`primaryDomain` are empty strings. We
 * fall back to the primary domain, then the raw id, so every option still
 * renders something selectable (an empty option would otherwise show a blank,
 * unpickable row).
 *
 * @param org - The organization entry.
 * @returns A non-empty label: name, else primaryDomain, else id.
 */
export function orgOptionLabel(org: Org): string {
  return org.name?.trim() || org.primaryDomain?.trim() || org.id;
}
